import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store";
import config from "@/data/config.json";

import LandingView from "@/views/LandingView.vue";
import ActivityView from "@/views/ActivityView.vue";
import TillageImplementsView from "@/views/TillageImplementsView.vue";

import { adminRoutes, authUser } from "@/admin/admin.js";

// Base title from config
const baseTitle = config.meta.title;

/*
 * All routes should be lowercase.
 * Each route includes a meta.title for accessibility (WCAG 2.4.2)
 */
const baseRoutes = [
  {
    path: store.getters.useLandingPage ? "/" : "/landing",
    name: "Landing",
    component: LandingView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    meta: { title: "Overview" }
  },
  {
    path: store.getters.useLandingPage ? "/activity" : "/",
    name: "Activity",
    component: ActivityView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    meta: { title: "Tillage Simulation" }
  },
  {
    path: "/tillage-implements",
    name: "TillageImplements",
    component: TillageImplementsView,
    beforeEnter: store.getters.useAuth ? authUser : null,
    meta: { title: "Tillage Implements" }
  }
];

/**
 * If the application uses authentication, then add the admin routes.
 */
export const routes = store.getters.useAuth
  ? [...baseRoutes, ...adminRoutes]
  : baseRoutes;

/*
 *
 * https://router.vuejs.org/guide/essentials/history-mode.html#hash-mode
 *
 * We use hash mode (createWebHashHistory), instead of
 * html5 mode (createWebHistory) so that it works on our S3 deployments.
 * The html5 mode is more SEO-friendly, but that isn't a concern with our
 * applications.
 */
/*
 * The 'linkExactActiveClass' is intended to style any router-view which
 * connects to the active view with the bold. It primarily will appear
 * in the `navbar`, but it will also bold any router-views, including buttons.
 */
const router = createRouter({
  linkExactActiveClass: "fw-bold",
  history: createWebHashHistory(),
  routes
});

/**
 * Update document title on navigation (WCAG 2.4.2 Page Titled)
 * Format: "Page Title | App Title"
 */
router.afterEach((to) => {
  const pageTitle = to.meta?.title || to.name;
  document.title = pageTitle ? `${pageTitle} | ${baseTitle}` : baseTitle;
});

export default router;
